import { useEffect } from "react";
import { getEnvironment } from "../utils/getEnvironment";

declare global {
    interface Window {
        Weglot?: {
            initialize: (config: {
                api_key: string;
                auto_switch: boolean;
                wait_transition?: boolean;
                hide_switcher?: boolean;
                extra_definitions?: Array<{
                    type: number;
                    selector: string;
                    attribute: string;
                }>;
            }) => void;
            options: {
                languages: Array<{
                    language_from: string;
                    language_to: string;
                }>;
                language_from: string;
            };
            getCurrentLang: () => string;
            getLanguageName: (lang: string) => string;
            switchTo: (lang: string) => void;
            on: (event: string, callback: (...args: any[]) => void) => void;
        };
    }
}

const environment = getEnvironment();

const useWeglot = () => {
    useEffect(() => {
        if (window.Weglot) {
            window.Weglot.initialize({
                api_key: environment.weglot_api_key,
                auto_switch: true,
                wait_transition: true,
                hide_switcher: true,
            });
        }
    }, []);
};

export default useWeglot;
